import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Register from './Components/Register/Register'
import SuccessRegister from './Components/Register/Success'
import ConfirmPayment from './Components/Register/ConfirmPayment'
import SuccessConfirmPayment from './Components/Register/SuccessConfirmPayment'
import BiodataRegister from './Components/Biodata/Register'
import EducationRegister from './Components/Biodata/Education'
import WorkingRegister from './Components/Biodata/Working'
import AlreadyConfirmPayment from './Components/Register/AlreadyConfirmPayment'
import SuccessBiodata from './Components/Biodata/SuccessBiodata'
import LoginParticipant from './Components/Participant/Login'
import HomeParticipant from './Components/Participant/Home'
import BiodataRegisterNew from './Components/Biodata/RegisterNew'
import WorkingLogin from './Components/Biodata/WorkingLogin'
import PaymentPackage from './Components/Register/PaymentPackage'
import AccessDenied from './Components/Participant/AccessDenied'
import Profile from './Components/Profile/Profile'
import MenuProfile from './Components/Menu/MenuProfile'
import MenuHome from './Components/Menu/MenuHome'
import MenuWelcome from './Components/Menu/MenuWelcome'
import MenuScholar from './Components/Menu/MenuScholar'

function App() {
  return (
    <Router basename={'/participant'}>
      <div>
        <Switch>
          <Route exact path="/denied">
            <AccessDenied />
          </Route>
          <Route exact path="/menu/welcome">
            <MenuWelcome />
          </Route>
          <Route exact path="/menu/scholar">
            <MenuScholar />
          </Route>
          <Route exact path="/menu/profile">
            <MenuProfile />
          </Route>
          <Route exact path="/menu/home">
            <MenuHome />
          </Route>
          <Route exact path="/profile">
            <Profile />
          </Route>
          <Route exact path="/register">
            <Register />
          </Route>
          <Route path="/biodata/login/working">
            <WorkingLogin />
          </Route>
          <Route exact path="/participant/home">
            <HomeParticipant />
          </Route>
          <Route exact path="/participant/login">
            <LoginParticipant />
          </Route>
          <Route exact path="/register/package">
            <PaymentPackage />
          </Route>
          <Route exact path="/register/success">
            <SuccessRegister />
          </Route>
          <Route exact path="/payment/confirm/success">
            <SuccessConfirmPayment />
          </Route>
          <Route path="/payment/confirm/:token">
            <ConfirmPayment />
          </Route>
          <Route path="/biodata/register/:token">
            <BiodataRegister />
          </Route>
          <Route path="/participant/register/biodata">
            <BiodataRegisterNew />
          </Route>
          <Route path="/biodata/education">
            <EducationRegister />
          </Route>
          <Route path="/biodata/working">
            <WorkingRegister />
          </Route>
          <Route path="/biodata/success">
            <SuccessBiodata />
          </Route>
          <Route path="/payment/duplicate">
            <AlreadyConfirmPayment />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
